import EvaluateResult from "../../EvaluateResult"
import RemoteConfigEvaluateRequest from "./RemoteConfigEvaluateRequest"
import { DecisionReason, HackleValue, MatchValueType, RemoteConfigParameterValue } from "../../../model/model"
import ObjectUtil from "../../../util/ObjectUtil"

/**
 * The value and reason a remote-config evaluation resolves to. `of` re-attributes the reason to
 * TYPE_MISMATCH when the resolved value does not satisfy the caller's required type; the value is
 * kept so the decision layer can fall back to the caller's default. Server-resolved results skip
 * the check by implementing this type directly.
 */
export default class RemoteConfigEvaluateResult implements EvaluateResult {
  private constructor(readonly reason: DecisionReason, readonly value: RemoteConfigParameterValue | undefined) {}

  static of(reason: DecisionReason, value: RemoteConfigParameterValue | undefined) {
    return new RemoteConfigEvaluateResult(reason, value)
  }

  static fromRequest(
    request: RemoteConfigEvaluateRequest,
    reason: DecisionReason,
    value: RemoteConfigParameterValue | undefined
  ): RemoteConfigEvaluateResult {
    if (ObjectUtil.isNullOrUndefined(value)) {
      return RemoteConfigEvaluateResult.of(reason, value)
    }
    return RemoteConfigEvaluateResult.isInstanceOf(value.rawValue, request.requiredType)
      ? RemoteConfigEvaluateResult.of(reason, value)
      : RemoteConfigEvaluateResult.of(DecisionReason.TYPE_MISMATCH, value)
  }

  private static isInstanceOf(rawValue: HackleValue, requiredType: MatchValueType): boolean {
    switch (requiredType) {
      case "NULL":
        return true
      case "STRING":
        return typeof rawValue === "string"
      case "NUMBER":
        return typeof rawValue === "number"
      case "BOOLEAN":
        return typeof rawValue === "boolean"
      default:
        return false
    }
  }
}
